export const DEFAULT_LANGUAGE = 'ID';
export const JWT_TOKEN_KEY = 'token';
export const STORAGE_LANG_KEY = 'lang';
export const DB_DATE_FORMAT = 'YYYY-MM-DD';
export const DB_TIMESTAMP_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const APP_DATE_FORMAT = 'MM/DD/YYYY';
export const APP_SHORT_DATE_FORMAT = 'D MMM YYYY';
export const APP_DATETIME_COMPLETE_FORMAT = 'dddd, D MMMM YYYY HH:mm:ss';
export const PICKER_DATE_FORMATS = {
    parse: { dateInput: 'YYYY-MM-DD' }, // Change 'LL' to 'DD MMMM YYYY'
    display: {
        dateInput: 'MM/DD/YYYY', // Change 'LL' to 'DD MMMM YYYY'
        monthYearLabel: 'MMM YYYY', // You can keep this format if you want
        dateA11yLabel: 'LL', // You can keep this format if you want
        monthYearA11yLabel: 'MMMM YYYY', // You can keep this format if you want
    },
};
